import React from 'react';
import { Box, Typography } from '@mui/material';
import Select from 'react-select';

function CustomReactSelect(props) {
    const {
        label,
        options,
        selectedOption,
        handleFilter,
        placeholder='',
        disable=false,
        innerPadding='0',
        index,
        customStyle={},
        isOptionsSearchable=true,
        multipleSelect=false,
        defaultOption,
        useMenuPortalTarget=false,
        formatOptionLabel,
        components,
        menuIsOpen,
        onMenuOpen,
        onMenuClose,
        selectedValueColor='black',
        data_test_id,
        isSorted=false
    } = props;
    const sortedOptions = !isSorted ? (options ? [...options].sort((a, b) => a?.label?.localeCompare(b?.label)) : []) : options;
    const handleFilterChange = (option, actionMeta) => {
        if (index !== undefined) {
            handleFilter(index, option);
        } else {
            if(multipleSelect){
                handleFilter(option, actionMeta);
            } else {
                handleFilter(option);
            }
        }
    };

    return (
        <Box className="flex-column gap-6 w-100">
            {label && (<Typography className='text-sm-medium gray-700'>
                {label}
            </Typography>)}
            <Select
                components = {components}
                data-testid ={data_test_id}
                defaultValue={defaultOption || placeholder}
                formatOptionLabel= {formatOptionLabel}
                isDisabled={disable}
                isMulti={multipleSelect}
                isSearchable={isOptionsSearchable } 
                menuIsOpen ={ menuIsOpen}
                menuPortalTarget={useMenuPortalTarget ? document.body : null}
                options={sortedOptions}
                placeholder={placeholder}
                styles={{
                    control: (base, state) => ({
                        ...base,
                        border: state.isFocused ? '1px solid #a04d97' : '1px solid #D0D5DD',
                        '&:hover': { border: state.isFocused ? '1px solid #a04d97' : '1px solid #D0D5DD' },
                        boxShadow: 'none',
                        padding: innerPadding,
                        ...customStyle
                    }),
                    dropdownIndicator: (base, state) => ({
                        ...base,
                        color: state.isFocused ? '#a04d97' : '#a04d97',
                        '&:hover': { color: state.isFocused ? '#a04d97' : '#a04d97' }
                    }),
                    indicatorSeparator: (base) => ({
                        ...base,
                        backgroundColor: '#a04d97'
                    }),
                    option: (base, state) => ({
                        ...base,
                        backgroundColor: state.isFocused ? '#8C3F7D' : 'white',
                        color: state.isFocused ? '#FFFFFF' : 'black'
                    }),
                    singleValue: (base, state) => ({
                        ...base,
                        color: selectedValueColor // Change selected value color based on focus state
                    }),
                    menuPortal: base => ({ ...base, zIndex: 9999 })
                }}
                value={selectedOption}
                onChange={handleFilterChange}
                onMenuClose ={onMenuClose}
                onMenuOpen ={onMenuOpen}
            />
        </Box>);
}


export default CustomReactSelect;